export default __webpack_public_path__ + "static/media/icon-shop.d62f2acb.svg";